export enum CRoutes {
    SignIn = "/sign-in",
    Plans = "/",
    AddPlan = "/add-plan",
    APlan = "/plan/:id",
}
